var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            [
              _c("el-breadcrumb-item", [_vm._v("业务管理")]),
              _c("el-breadcrumb-item", [_vm._v("工单审计")]),
              _c("el-breadcrumb-item", [_vm._v("DCOPS审计")])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("查询条件")]),
      _c(
        "el-card",
        { staticClass: "box-card audit-search-card" },
        [
          _c(
            "el-tabs",
            {
              staticClass: "audit-tabs",
              on: { "tab-click": _vm.onAuditTabClick },
              model: {
                value: _vm.activeAuditTab,
                callback: function($$v) {
                  _vm.activeAuditTab = $$v
                },
                expression: "activeAuditTab"
              }
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "主动审计", name: "active" } },
                [
                  _c(
                    "div",
                    { staticClass: "search-container" },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "search-form",
                          attrs: {
                            inline: true,
                            model: _vm.searchFormActive,
                            "label-width": "100px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "创建时间" } },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "daterange",
                                          "range-separator": "-",
                                          "start-placeholder": "开始日期",
                                          "end-placeholder": "结束日期",
                                          "value-format": "yyyy-MM-dd"
                                        },
                                        model: {
                                          value:
                                            _vm.searchFormActive.createdRange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchFormActive,
                                              "createdRange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchFormActive.createdRange"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "工单号" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入工单号",
                                          clearable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.searchFormActive.op_ticketid,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchFormActive,
                                              "op_ticketid",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchFormActive.op_ticketid"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "待办工单号" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "JSON 内 mainTicketId",
                                          clearable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.searchFormActive.main_ticket_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchFormActive,
                                              "main_ticket_id",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchFormActive.main_ticket_id"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "审计结果" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "全部"
                                          },
                                          model: {
                                            value:
                                              _vm.searchFormActive.audit_result,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.searchFormActive,
                                                "audit_result",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchFormActive.audit_result"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "通过",
                                              value: "通过"
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "不通过",
                                              value: "不通过"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "场景" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder:
                                            "如：网络运营 / 服务器运营",
                                          clearable: ""
                                        },
                                        model: {
                                          value: _vm.searchFormActive.scene,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchFormActive,
                                              "scene",
                                              $$v
                                            )
                                          },
                                          expression: "searchFormActive.scene"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "工单类型" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "模糊查询",
                                          clearable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.searchFormActive.ticket_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchFormActive,
                                              "ticket_type",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchFormActive.ticket_type"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "机房" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "一级机房",
                                          clearable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.searchFormActive
                                              .auditinfo_idcp_name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchFormActive,
                                              "auditinfo_idcp_name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchFormActive.auditinfo_idcp_name"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "状态" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "全部"
                                          },
                                          model: {
                                            value:
                                              _vm.searchFormActive
                                                .process_status,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.searchFormActive,
                                                "process_status",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchFormActive.process_status"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "运行中",
                                              value: "running"
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "结束",
                                              value: "finished"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            {
                              staticClass: "search-actions-row",
                              attrs: { gutter: 20 }
                            },
                            [
                              _c("el-col", { attrs: { span: 24 } }, [
                                _c(
                                  "div",
                                  { staticClass: "search-button" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.handleSearch }
                                      },
                                      [_vm._v("点击查询")]
                                    ),
                                    _c(
                                      "el-button",
                                      { on: { click: _vm.handleResetActive } },
                                      [_vm._v("重置")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { loading: _vm.exportLoading },
                                        on: { click: _vm.debouncedExport }
                                      },
                                      [_vm._v(_vm._s(_vm.exportButtonText))]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "被动审计", name: "passive" } },
                [
                  _c(
                    "div",
                    { staticClass: "search-container" },
                    [
                      _c(
                        "el-form",
                        {
                          staticClass: "search-form",
                          attrs: {
                            inline: true,
                            model: _vm.searchFormPassive,
                            "label-width": "100px"
                          }
                        },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "创建时间" } },
                                    [
                                      _c("el-date-picker", {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          type: "daterange",
                                          "range-separator": "-",
                                          "start-placeholder": "开始日期",
                                          "end-placeholder": "结束日期",
                                          "value-format": "yyyy-MM-dd"
                                        },
                                        model: {
                                          value:
                                            _vm.searchFormPassive.createdRange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchFormPassive,
                                              "createdRange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchFormPassive.createdRange"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "工单号" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "请输入工单号",
                                          clearable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.searchFormPassive.op_ticketid,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchFormPassive,
                                              "op_ticketid",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchFormPassive.op_ticketid"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "待办工单号" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "JSON 内 mainTicketId",
                                          clearable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.searchFormPassive
                                              .main_ticket_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchFormPassive,
                                              "main_ticket_id",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchFormPassive.main_ticket_id"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "审计结果" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "全部"
                                          },
                                          model: {
                                            value:
                                              _vm.searchFormPassive
                                                .audit_result,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.searchFormPassive,
                                                "audit_result",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchFormPassive.audit_result"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "通过",
                                              value: "通过"
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "不通过",
                                              value: "不通过"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            { attrs: { gutter: 20 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "复核结果" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "全部"
                                          },
                                          model: {
                                            value:
                                              _vm.searchFormPassive
                                                .review_result,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.searchFormPassive,
                                                "review_result",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchFormPassive.review_result"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "复核无误",
                                              value: "复核无误"
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "申诉",
                                              value: "申诉"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "最终结果" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "全部"
                                          },
                                          model: {
                                            value:
                                              _vm.searchFormPassive
                                                .final_result,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.searchFormPassive,
                                                "final_result",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchFormPassive.final_result"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "通过",
                                              value: "通过"
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "不通过",
                                              value: "不通过"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "审计机房" } },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          placeholder: "一级机房",
                                          clearable: ""
                                        },
                                        model: {
                                          value:
                                            _vm.searchFormPassive
                                              .audit_result_idcp_name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.searchFormPassive,
                                              "audit_result_idcp_name",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "searchFormPassive.audit_result_idcp_name"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { label: "状态" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            clearable: "",
                                            placeholder: "全部"
                                          },
                                          model: {
                                            value:
                                              _vm.searchFormPassive
                                                .process_status,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.searchFormPassive,
                                                "process_status",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "searchFormPassive.process_status"
                                          }
                                        },
                                        [
                                          _c("el-option", {
                                            attrs: {
                                              label: "运行中",
                                              value: "running"
                                            }
                                          }),
                                          _c("el-option", {
                                            attrs: {
                                              label: "结束",
                                              value: "finished"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-row",
                            {
                              staticClass: "search-actions-row",
                              attrs: { gutter: 20 }
                            },
                            [
                              _c("el-col", { attrs: { span: 24 } }, [
                                _c(
                                  "div",
                                  { staticClass: "search-button" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "primary" },
                                        on: { click: _vm.handleSearch }
                                      },
                                      [_vm._v("点击查询")]
                                    ),
                                    _c(
                                      "el-button",
                                      { on: { click: _vm.handleResetPassive } },
                                      [_vm._v("重置")]
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { loading: _vm.exportLoading },
                                        on: { click: _vm.debouncedExport }
                                      },
                                      [_vm._v(_vm._s(_vm.exportButtonText))]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v(_vm._s(_vm.tableTitle))]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                  _vm._v("表头设置")
                ])
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.rows, border: "", stripe: "" }
              },
              _vm._l(_vm.visibleColumns, function(column, index) {
                return _c("el-table-column", {
                  key: column.prop + "-" + index,
                  attrs: {
                    prop: column.prop,
                    label: column.label,
                    width: column.width,
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            column.prop === "opTicketid"
                              ? _c("span", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.dcopsDetailHref(
                                          scope.row.opTicketid
                                        ),
                                        target: "_blank",
                                        rel: "noopener noreferrer"
                                      }
                                    },
                                    [_vm._v(_vm._s(scope.row.opTicketid))]
                                  )
                                ])
                              : column.prop === "main_ticket_display"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.mainTicketDisplay(scope.row))
                                  )
                                ])
                              : _vm.isJsonColumn(column.prop)
                              ? _c(
                                  "span",
                                  { staticClass: "json-cell-wrap" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "json-view-btn",
                                        attrs: { type: "text", size: "small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.openJsonDetail(
                                              scope.row,
                                              column.prop
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                查看详情\n              "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "json-cell-summary" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.jsonCellSummary(
                                              scope.row[column.prop],
                                              column.prop
                                            )
                                          )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : column.prop === "audit_result"
                              ? _c(
                                  "span",
                                  [
                                    _vm.isPendingAuditEmpty(
                                      scope.row.audit_result
                                    )
                                      ? _c(
                                          "span",
                                          { staticClass: "audit-pending" },
                                          [_vm._v("审计中...")]
                                        )
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.resultTagType(
                                                "audit",
                                                scope.row.audit_result
                                              ),
                                              size: "small",
                                              effect: "plain"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              class: [
                                                "result-ico",
                                                _vm.resultTagIcon(
                                                  "audit",
                                                  scope.row.audit_result
                                                )
                                              ]
                                            }),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(scope.row.audit_result) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                )
                              : column.prop === "review_result"
                              ? _c(
                                  "span",
                                  [
                                    _vm.isEmptyCell(scope.row.review_result)
                                      ? [_vm._v("-")]
                                      : _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.resultTagType(
                                                "review",
                                                scope.row.review_result
                                              ),
                                              size: "small",
                                              effect: "plain"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              class: [
                                                "result-ico",
                                                _vm.resultTagIcon(
                                                  "review",
                                                  scope.row.review_result
                                                )
                                              ]
                                            }),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  scope.row.review_result
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                  ],
                                  2
                                )
                              : column.prop === "finalResult"
                              ? _c(
                                  "span",
                                  [
                                    !_vm.isPendingAuditEmpty(
                                      scope.row.finalResult
                                    )
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: _vm.resultTagType(
                                                "final",
                                                scope.row.finalResult
                                              ),
                                              size: "small",
                                              effect: "plain"
                                            }
                                          },
                                          [
                                            _c("i", {
                                              class: [
                                                "result-ico",
                                                _vm.resultTagIcon(
                                                  "final",
                                                  scope.row.finalResult
                                                )
                                              ]
                                            }),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(scope.row.finalResult) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : !_vm.isPendingAuditEmpty(
                                          scope.row.review_result
                                        )
                                      ? _c(
                                          "span",
                                          { staticClass: "audit-pending" },
                                          [_vm._v("复核中")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : column.prop === "created_at" ||
                                column.prop === "updated_at"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatTime(scope.row[column.prop])
                                    )
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.cellText(scope.row[column.prop]))
                                  )
                                ])
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                })
              }),
              1
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: _vm.jsonDetailTitle,
                  visible: _vm.jsonDetailVisible,
                  "append-to-body": "",
                  width: "960px",
                  top: "6vh",
                  "custom-class": "json-detail-dialog",
                  "close-on-click-modal": false
                },
                on: {
                  "update:visible": function($event) {
                    _vm.jsonDetailVisible = $event
                  },
                  closed: _vm.onJsonDetailClosed
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "json-detail-body" },
                  [
                    _vm.jsonDetailMode === "review_file"
                      ? [
                          !_vm.jsonDetailRows.length
                            ? _c("div", { staticClass: "json-empty" }, [
                                _vm._v("暂无附件")
                              ])
                            : _c(
                                "ul",
                                { staticClass: "review-file-list" },
                                _vm._l(_vm.jsonDetailRows, function(f, idx) {
                                  return _c(
                                    "li",
                                    {
                                      key: idx,
                                      staticClass: "review-file-item"
                                    },
                                    [
                                      _c("i", {
                                        class: [
                                          "el-file-icon",
                                          _vm.isImageUrl(_vm.fileUrl(f))
                                            ? "el-icon-picture-outline"
                                            : "el-icon-document"
                                        ]
                                      }),
                                      _c(
                                        "a",
                                        {
                                          staticClass: "file-name",
                                          attrs: {
                                            href: _vm.fileUrl(f),
                                            target: "_blank",
                                            rel: "noopener noreferrer"
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.fileDisplayName(f)))]
                                      ),
                                      _vm.isImageUrl(_vm.fileUrl(f))
                                        ? _c(
                                            "div",
                                            { staticClass: "img-preview-wrap" },
                                            [
                                              _c("img", {
                                                staticClass: "thumb",
                                                attrs: {
                                                  src: _vm.fileUrl(f),
                                                  alt: ""
                                                },
                                                on: { error: _vm.onImgError }
                                              })
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                0
                              )
                        ]
                      : _vm.jsonDetailMode === "audit_info"
                      ? [
                          _vm.jsonDetailRows.length
                            ? _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.jsonDetailRows,
                                    border: "",
                                    stripe: "",
                                    size: "small",
                                    "max-height": "520"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "mainTicketId",
                                      label: "待办工单号",
                                      "min-width": "130",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "idcpName",
                                      label: "一级机房",
                                      "min-width": "140",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "completer",
                                      label: "业务结单人",
                                      "min-width": "100",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "ticketType",
                                      label: "工单类型",
                                      "min-width": "120",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "auditService",
                                      label: "审计服务商",
                                      "min-width": "100",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "auditedService",
                                      label: "被审计服务商",
                                      "min-width": "110",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "memo",
                                      label: "备注",
                                      "min-width": "120",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "工单链接",
                                      "min-width": "160"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(s) {
                                            return [
                                              s.row.ticketURL
                                                ? _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: s.row.ticketURL,
                                                        target: "_blank",
                                                        rel:
                                                          "noopener noreferrer"
                                                      }
                                                    },
                                                    [_vm._v("打开")]
                                                  )
                                                : _c("span", [_vm._v("-")])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2476318364
                                    )
                                  })
                                ],
                                1
                              )
                            : _c("div", { staticClass: "json-empty" }, [
                                _vm._v("暂无数据")
                              ])
                        ]
                      : _vm.jsonDetailMode === "ctrl_point_info"
                      ? [
                          _vm.jsonDetailRows.length
                            ? _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.jsonDetailRows,
                                    border: "",
                                    stripe: "",
                                    size: "small",
                                    "max-height": "520"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "ctrlContent",
                                      label: "管控内容",
                                      "min-width": "220",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "ctrlStandard",
                                      label: "管控标准",
                                      "min-width": "220",
                                      "show-overflow-tooltip": ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("div", { staticClass: "json-empty" }, [
                                _vm._v("暂无数据")
                              ])
                        ]
                      : _vm.jsonDetailMode === "audit_result_info"
                      ? [
                          _vm.jsonDetailRows.length
                            ? _c(
                                "el-table",
                                {
                                  attrs: {
                                    data: _vm.jsonDetailRows,
                                    border: "",
                                    stripe: "",
                                    size: "small",
                                    "max-height": "520"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "mainTicketId",
                                      label: "待办工单号",
                                      "min-width": "120",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "scene",
                                      label: "业务场景",
                                      "min-width": "100",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "ticketType",
                                      label: "工单类型",
                                      "min-width": "120",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "工单链接",
                                      "min-width": "100"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(s) {
                                            return [
                                              s.row.ticketURL
                                                ? _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: s.row.ticketURL,
                                                        target: "_blank",
                                                        rel:
                                                          "noopener noreferrer"
                                                      }
                                                    },
                                                    [_vm._v("打开")]
                                                  )
                                                : _c("span", [_vm._v("-")])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2476318364
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "ctrlStandard",
                                      label: "管控标准",
                                      "min-width": "140",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "ctrlContent",
                                      label: "管控内容",
                                      "min-width": "160",
                                      "show-overflow-tooltip": ""
                                    }
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "管控点审计结果",
                                      "min-width": "140",
                                      align: "center"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(s) {
                                            return [
                                              _vm.isEmptyCell(
                                                s.row.ctrlAuditResult
                                              )
                                                ? [_vm._v("-")]
                                                : _c(
                                                    "el-tag",
                                                    {
                                                      attrs: {
                                                        type: _vm.resultTagType(
                                                          "ctrl",
                                                          s.row.ctrlAuditResult
                                                        ),
                                                        size: "small",
                                                        effect: "plain"
                                                      }
                                                    },
                                                    [
                                                      _c("i", {
                                                        class: [
                                                          "result-ico",
                                                          _vm.resultTagIcon(
                                                            "ctrl",
                                                            s.row
                                                              .ctrlAuditResult
                                                          )
                                                        ]
                                                      }),
                                                      _vm._v(
                                                        "\n                    " +
                                                          _vm._s(
                                                            s.row
                                                              .ctrlAuditResult
                                                          ) +
                                                          "\n                  "
                                                      )
                                                    ]
                                                  )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      2853160183
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "ctrlAuditMemo",
                                      label: "管控点审计备注",
                                      "min-width": "160",
                                      "show-overflow-tooltip": ""
                                    }
                                  })
                                ],
                                1
                              )
                            : _c("div", { staticClass: "json-empty" }, [
                                _vm._v("暂无数据")
                              ])
                        ]
                      : _vm.jsonDetailMode === "raw"
                      ? [
                          _c("pre", { staticClass: "json-raw" }, [
                            _vm._v(_vm._s(_vm.jsonDetailRawText))
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "560px",
                  "close-on-click-modal": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }